import React, { useEffect } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { Chart } from 'react-chartjs-2';
import { ThemeProvider } from '@material-ui/styles';
import validate from 'validate.js';
import { useDispatch, useSelector } from 'react-redux';
import { chartjs } from './helpers';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import './assets/scss/index.scss';
import validators from './common/validators';
import Routes from './Routes';
import { Apploader } from './components/Apploaders';
import { actionGenerateUserSessionID, actionValidateRecaptchaReset, actionResetStopUserToPurchase } from 'actions';
import {
  GoogleReCaptchaProvider,
} from 'react-google-recaptcha-v3';
import { GoogleAnalytic, HotJarTracker } from 'components';

const { ExpiryTimeCacheInMins, RecaptchaV3Client, ResetLimitOfCallsTimer } = window['runConfig'];

const browserHistory = createBrowserHistory({ basename: '/items' });

Chart.helpers.extend(Chart.elements.Rectangle.prototype, {
  draw: chartjs.draw
});

validate.validators = {
  ...validate.validators,
  ...validators
};

export default function App() {
  const dispatch = useDispatch();

  const loading = useSelector(state => state.reducerAppLoader.loading);
  const sessionID = useSelector(state => state.reducerGlobal.sessionID);
  const stopUserToPurchase = useSelector(state => state.reducerGlobal.stopUserToPurchase);


  useEffect(() => {
    if (sessionID.length < 1) {
      actionGenerateUserSessionID(dispatch);
    }
  }, []);


  useEffect(() => {
    if (stopUserToPurchase === true) {
      var ms = ResetLimitOfCallsTimer * 60000;

      setInterval(function () {

        actionResetStopUserToPurchase(dispatch);
        actionValidateRecaptchaReset(dispatch);

      }, ms);

    }
  }, [stopUserToPurchase]);


  useEffect(() => {
    var ms = ExpiryTimeCacheInMins * 60000;
    setInterval(function () { window.location.reload(); }, ms);
  });

  return (
    <div>
      {RecaptchaV3Client && RecaptchaV3Client != "" ?
        <GoogleReCaptchaProvider
          reCaptchaKey={RecaptchaV3Client}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router history={browserHistory}>
              <Routes />
            </Router>
          </ThemeProvider>
          <Apploader loading={loading}></Apploader>
          <HotJarTracker />
          <GoogleAnalytic />
        </GoogleReCaptchaProvider>
        :
        <>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <Router history={browserHistory}>
              <Routes />
            </Router>
          </ThemeProvider>
          <Apploader loading={loading}></Apploader>
          <HotJarTracker />
          <GoogleAnalytic />
        </>
      }
    </div>
  )
}
